module.exports = __webpack_public_path__ + "static/olark-logo-8bbdfc5d1d636fd683075b39613ba030.png";